import Vue from 'vue'
import Router from 'vue-router'
import defaultPage from '@/components/default'
import login from '@/components/login/login'
import userIndex from '@/components/index'
import userInfo from '@/components/userMana/userInfo'
import depart from '@/components/userMana/depart'
import role from '@/components/userMana/role'

import dinnerState from '@/components/dinnerMana/dinnerState'
import dinnerMonth from '@/components/dinnerMana/dinnerMonth'
import mealSetting from '@/components/dinnerMana/mealSetting'
import wxSend from '@/components/dinnerMana/wxSend'
import wxDinner from '@/components/dinnerMana/wxDinner'
import wxDinner0 from '@/components/dinnerMana/wxDinner0'
import wxStatistics from '@/components/dinnerMana/wxStatistics'
import wxEntertain from '@/components/dinnerMana/wxEntertain'
import wxAddMeal from '@/components/dinnerMana/wxAddMeal'
import wxEnterList from '@/components/dinnerMana/wxEnterList'
import wxEditEnter from '@/components/dinnerMana/wxEditEnter'
import order from '@/components/dinnerMana/order'
import menu from '@/components/dinnerMana/menu'

import infoList from '@/components/infoMana/infoList'
import addInfo from '@/components/infoMana/addInfo'
import wxList from '@/components/infoMana/wxList'
import wxSign from '@/components/infoMana/wxSign'
import editInfo from '@/components/infoMana/editInfo'
import holiday from '@/components/infoMana/holiday'
import test from '@/components/infoMana/test'

import bigScreen from '@/components/bigScreen/bigScreen'

import asetsList from '@/components/propertyMana/asetsList'
import asetDetail from '@/components/propertyMana/asetDetail'
import buildAsets from '@/components/propertyMana/buildAsets'
import allocationRecord from '@/components/propertyMana/allocationRecord'
import lendRecord from '@/components/propertyMana/lendRecord'
import scrapRecord from '@/components/propertyMana/scrapRecord'
import wxProperty from '@/components/propertyMana/wxProperty'
import wxAllProperty from '@/components/propertyMana/wxAllProperty'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/default'
    },
    {
      path: '/default',
      component: defaultPage
    },
    {
      path: '/login',
      component: login
    },
    {
      path: '/data',
      component: userIndex,
      children: [
        {path: '/data/info', component: userInfo},
        {path: '/data/depart', component: depart},
        {path: '/data/role', component: role},
				
        {path: '/data/dinnerState', component: dinnerState},
        {path: '/data/dinnerMonth', component: dinnerMonth},
        {path: '/data/mealSetting', component: mealSetting},
        {path: '/data/wxSend/:openid', component: wxSend,props: true},
        {path: '/data/wxDinner/:wxCodeT', component: wxDinner,props: true},
        {path: '/data/wxDinner', component: wxDinner0},
        {path: '/data/wxStatistics/:wxCode', component: wxStatistics,props: true},
        {path: '/data/wxEntertain/:wxCode', component: wxEntertain,props: true},
        {path: '/data/wxAddMeal/:wxCode', component: wxAddMeal,props: true},
        {path: '/data/wxEnterList/:wxCode', component: wxEnterList,props: true},
        {path: '/data/wxEditEnter/:listId', component: wxEditEnter,props: true},
        {path: '/data/order', component: order},
        {path: '/data/menus', component: menu},

        {path: '/data/infoList', component: infoList},
        {path: '/data/addInfo', component: addInfo},
        {path: '/data/wxList/:wxCode', component: wxList,props: true},
        {path: '/data/wxSign/:username/:id', component: wxSign,props: true},
        {path: '/data/editInfo/:infoId', component: editInfo,props: true},
        {path: '/data/holiday', component: holiday},
        {path: '/data/test', component: test},

        {path: '/data/bigScreen', component: bigScreen,props: true},

          {path: '/data/asetsList', component: asetsList},
          {path: '/data/asetDetail',name:'asetDetail', component: asetDetail},
          {path: '/data/buildAsets', name:'buildAsets',component: buildAsets},
          {path: '/data/allocationRecord', component: allocationRecord},
          {path: '/data/lendRecord', component: lendRecord},
          {path: '/data/scrapRecord', component: scrapRecord},
          {path: '/data/wxProperty/:wxCode/:id', component: wxProperty,props: true},
          {path: '/data/wxAllProperty/:wxCode/:class_type', component: wxAllProperty,props: true},

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js